import { isNil } from 'es-toolkit';
import { TrendingUp } from 'lucide-react';

import { greyIconsColor } from '@savvy/deprecated-shared/theme';
import { mapIconColorToPalette } from '@savvy/deprecated-shared/theme/utils';

import type { XIconProps } from './types';
import { DEFAULT_ICON_SIZE } from './types';

export function XTrendingUp({ color, size = DEFAULT_ICON_SIZE, style, onClick }: XIconProps) {
  let mappedColor = greyIconsColor;
  if (!isNil(color)) {
    mappedColor = mapIconColorToPalette[color] ?? color;
  }
  return <TrendingUp onClick={onClick} style={{ color: mappedColor, height: size, width: size, ...style }} />;
}
